import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTextAlignRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="lucide lucide-align-right"
    viewBox="0 0 24 24"
    aria-label="IconTextAlignRight"
    stroke="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M21 12H9M21 18H7M21 6H3" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTextAlignRight);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
